import styled from "styled-components";
import { WrapperContainer } from "..";

export const FirmwareVersionInputContainer = styled(WrapperContainer)``;

export const FirmwareInputVersionWrapper = styled(WrapperContainer)`
  width: 40px;

  input[type="number"] {
    padding: 0 8px;
  }
`;
